import type { FC } from "react"
import { Navigate, Outlet, useLocation } from "react-router"
import { AdminTopNav } from "@/components/admin/admin-top-nav"
import { useCurrentUser } from "@/lib/useCurrentUser"

export const AuthenticatedLayout: FC = () => {
  const currentUser = useCurrentUser()
  const location = useLocation()

  if (!currentUser) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return (
    <main className="min-h-screen bg-white">
      <AdminTopNav />
      <section className="mx-auto w-full max-w-[1280px] px-6 py-6">
        <Outlet />
      </section>
    </main>
  )
}
